import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'ShowResult',
    component: () => import('../views/ShowResult.vue')
  },
  {
    path: '/date/:pathDate',
    name: 'HistoryResult',
    component: () => import('../views/HistoryResult.vue')
  },
  /*{
    path: '/lotto/0/:goPath(.*?)',
    name: 'IframeResult',
    component: () => import('../views/IframeResult.vue')
  },*/
  {
    path: '/xo-so/:goPath(.*?)',
    name: 'IframeResult1',
    component: () => import('../views/IframeResult1.vue')
  },
  {
    path: '/lotto/:goPath(.*?)',
    name: 'IframeResult',
    component: () => import('../views/IframeResult.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
